export default __webpack_public_path__ + "assets/images/coupon_empty.png?9cd5329939bd75ac62516c1b25a045f6";